import { useQuery } from '@tanstack/react-query'
import {
  fetchAdminDashboardAggregator,
  fetchStudentDashboardAggregator,
  fetchStaffDashboardAggregator,
  fetchCentralizedKpis,
  fetchStudentKpis,
  fetchStaffKpis,
  fetchSeatKpis,
  fetchAcademicKpis,
  fetchSubjectKpis,
  fetchUserKpis,
  fetchRoleKpis,
  fetchDepartmentKpis,
  fetchDesignationKpis,
  fetchCommunicationKpis,
} from '../api/dashboardKpisApi'

export const DASHBOARD_KPI_KEYS = {
  ADMIN_AGGREGATOR: ['dashboard', 'admin'],
  STUDENT_AGGREGATOR: ['dashboard', 'student'],
  STAFF_AGGREGATOR: ['dashboard', 'staff'],
  CENTRALIZED_KPIS: ['dashboard', 'kpis'],
  STUDENT_KPIS: ['dashboard', 'kpis', 'student'],
  STAFF_KPIS: ['dashboard', 'kpis', 'staff'],
  SEAT_KPIS: ['dashboard', 'kpis', 'seat'],
  ACADEMIC_KPIS: ['dashboard', 'kpis', 'academic'],
  SUBJECT_KPIS: ['dashboard', 'kpis', 'subject'],
  USER_KPIS: ['dashboard', 'kpis', 'user'],
  ROLE_KPIS: ['dashboard', 'kpis', 'role'],
  DEPARTMENT_KPIS: ['dashboard', 'kpis', 'department'],
  DESIGNATION_KPIS: ['dashboard', 'kpis', 'designation'],
  COMMUNICATION_KPIS: ['communications', 'dashboard'],
}

/** 1. Centralized Admin Dashboard Aggregator Hook */
export const useAdminDashboardAggregator = () => {
  return useQuery({
    queryKey: DASHBOARD_KPI_KEYS.ADMIN_AGGREGATOR,
    queryFn: fetchAdminDashboardAggregator,
    staleTime: 5 * 60 * 1000,
  })
}

/** 2. Centralized Student Dashboard Aggregator Hook */
export const useStudentDashboardAggregator = () => {
  return useQuery({
    queryKey: DASHBOARD_KPI_KEYS.STUDENT_AGGREGATOR,
    queryFn: fetchStudentDashboardAggregator,
    staleTime: 5 * 60 * 1000,
  })
}

/** 3. Centralized Staff Dashboard Aggregator Hook */
export const useStaffDashboardAggregator = () => {
  return useQuery({
    queryKey: DASHBOARD_KPI_KEYS.STAFF_AGGREGATOR,
    queryFn: fetchStaffDashboardAggregator,
    staleTime: 5 * 60 * 1000,
  })
}

/** 4. Centralized Multi-Domain Dashboard KPI Metrics Hook */
export const useCentralizedKpis = () => {
  return useQuery({
    queryKey: DASHBOARD_KPI_KEYS.CENTRALIZED_KPIS,
    queryFn: fetchCentralizedKpis,
    staleTime: 5 * 60 * 1000,
  })
}

/** 5. Student Domain KPI Metrics Hook */
export const useStudentKpis = () => {
  return useQuery({
    queryKey: DASHBOARD_KPI_KEYS.STUDENT_KPIS,
    queryFn: fetchStudentKpis,
    staleTime: 5 * 60 * 1000,
  })
}

/** 6. Staff Management KPI Metrics Hook */
export const useStaffKpis = () => {
  return useQuery({
    queryKey: DASHBOARD_KPI_KEYS.STAFF_KPIS,
    queryFn: fetchStaffKpis,
    staleTime: 5 * 60 * 1000,
  })
}

/** 7. Seat Management KPI Metrics Hook */
export const useSeatKpis = () => {
  return useQuery({
    queryKey: DASHBOARD_KPI_KEYS.SEAT_KPIS,
    queryFn: fetchSeatKpis,
    staleTime: 5 * 60 * 1000,
  })
}

/** 8. Academic Domain KPI Metrics Hook */
export const useAcademicKpis = () => {
  return useQuery({
    queryKey: DASHBOARD_KPI_KEYS.ACADEMIC_KPIS,
    queryFn: fetchAcademicKpis,
    staleTime: 5 * 60 * 1000,
  })
}

/** 9. Subject Management KPI Metrics Hook */
export const useSubjectKpis = () => {
  return useQuery({
    queryKey: DASHBOARD_KPI_KEYS.SUBJECT_KPIS,
    queryFn: fetchSubjectKpis,
    staleTime: 5 * 60 * 1000,
  })
}

/** 10. User Management KPI Metrics Hook */
export const useUserKpis = () => {
  return useQuery({
    queryKey: DASHBOARD_KPI_KEYS.USER_KPIS,
    queryFn: fetchUserKpis,
    staleTime: 5 * 60 * 1000,
  })
}

/** 11. Role Management KPI Metrics Hook */
export const useRoleKpis = () => {
  return useQuery({
    queryKey: DASHBOARD_KPI_KEYS.ROLE_KPIS,
    queryFn: fetchRoleKpis,
    staleTime: 5 * 60 * 1000,
  })
}

/** 12. Department Management KPI Metrics Hook */
export const useDepartmentKpis = () => {
  return useQuery({
    queryKey: DASHBOARD_KPI_KEYS.DEPARTMENT_KPIS,
    queryFn: fetchDepartmentKpis,
    staleTime: 5 * 60 * 1000,
  })
}

/** 13. Designation Management KPI Metrics Hook */
export const useDesignationKpis = () => {
  return useQuery({
    queryKey: DASHBOARD_KPI_KEYS.DESIGNATION_KPIS,
    queryFn: fetchDesignationKpis,
    staleTime: 5 * 60 * 1000,
  })
}

/** 14. Communication Dashboard KPI Metrics Hook (GET /api/communications/dashboard) */
export const useCommunicationKpis = () => {
  return useQuery({
    queryKey: DASHBOARD_KPI_KEYS.COMMUNICATION_KPIS,
    queryFn: fetchCommunicationKpis,
    staleTime: 5 * 60 * 1000,
  })
}
